'use strict';

var cacheFactory = require('cache-factory');
var serverData = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var slideshowUtils = require('./slideshow-utils');

var galleryData;
var lastPageData = {};

var setLastPageData = function(data) {

	lastPageData = data;

};

var getLastPageData = function() {

	return lastPageData;

};

var getWatermarkMeta = function() {

	return serverData.event.watermark;

};

var getUrlParams = function() {

	return '&page=gallery';

};

var getEventName = function() {

	return serverData.event.name;

};

var getEventKey = function() {

	return serverData.event.key;

};

var getEventDefaultShareImage = function() {

	return serverData.event.defaultShareImage;

};

var getEventUrl = function() {

	return serverData.root + '/' + serverData.event.friendlyName;
};

var getGalleryData = function() {

	return galleryData;

};

var getGalleryIndex = function() {

	var state = window.history.state;

	return state && state.galleryIndex;

};

var getFavoritesGalleryIndex = function() {

	// Favorites gallery is always last.
	return serverData.event.galleries.length - 1;

};

var getGalleryMeta = function(galleryIndex) {

	galleryIndex = typeof galleryIndex === 'undefined' ? getGalleryIndex() : galleryIndex;

	return serverData.event.galleries[galleryIndex];

};

var getSlideshowIndex = function() {

	var state = window.history.state;

	return state && state.slideshowIndex;

};

var getImageMeta = function(imageIndex) {

	imageIndex = typeof imageIndex === 'undefined' ? getSlideshowIndex() : imageIndex;

	return galleryData[imageIndex];

};

var getImageUrl = function(imageSize, opts) {

	var imageMeta;

	opts = opts || {};

	imageMeta = getImageMeta(opts.imageIndex);

	return imageMeta.baseUrl + imageMeta.sizes[imageSize] + imageMeta.ext;

};

var getGalleryUrl = function(galleryIndex) {

	console.log('galleryIndex');
	console.log(galleryIndex);

	console.log('galleryMeta');
	console.log(getGalleryMeta(galleryIndex));

	return getEventUrl() + '/' + getGalleryMeta(galleryIndex).friendlyName;

};

var getSlideshowUrl = function(galleryIndex, imageIndex) {

	return getGalleryUrl(galleryIndex) + '/' + getImageMeta(imageIndex).friendlyName;

};

var getPhotographerAccountId = function() {

	return serverData.photographer.accountId;

};

var getPhotographerCompanyName = function() {

	return serverData.photographer.company;

};

// We want to make sure the only way to get to a slideshow is by clicking an image in the grid or from a deep link. In order to do this, sometimes we want to push new gallery grid pages onto the stack, and sometimes we want to replace the current stack entry. If we're currently in the slideshow, replace the current history stack entry with the new gallery grid, if we're currently in a grid, push the new gallery grid onto the stack.
var getHistoryAction = function() {

	return isSlideshowState() ? 'replace' : 'push';

};

// Since some browsers put a limit on the storage size of the history state,
// we will store the gallery data in an internal memory cache. All other page
// state data will be stored in the history state object.
var fetch;
var setupCacheFactory = function(initialUrl, initialGalleryData) {

	fetch = cacheFactory(function(defer, url) {

		url = url.indexOf('?') === -1 ? url + '?' : url;

		// Request the gallery data.
		$.ajax({
			cache: false,
			url: url + getUrlParams()
		})
		.done(function(ajaxJson) {

			// Resolve the deferred with the returned gallery data.
			defer.resolve(JSON.parse(ajaxJson));

		})
		.fail(defer.reject);

	}, {
		// Seed the cache with the initial gallery data provided by the server.
		seed: [
			{
				key: initialUrl,
				args: [initialGalleryData]
			}
		]
	});

};

var isFavoritesGallery = function(galleryIndex) {

	return getGalleryMeta(galleryIndex).friendlyName === 'favorites';

};

var isCachableGallery = function(galleryIndex) {

	// Right now, all galleries except favorites are cachable.

	return !isFavoritesGallery(galleryIndex);

};

var isSlideshowState = function() {

	return typeof getSlideshowIndex() !== 'undefined';

};

var isGridState = function() {

	return !isSlideshowState();

};

var hasFavoritesEnabled = function() {

	return serverData.event.hasFavoritesEnabled;

};

var hasEcommerceEnabled = function() {

	return serverData.event.hasEcommerceEnabled;

};

var hasDownloadsEnabled = function() {

	return serverData.event.hasDownloadsEnabled;

};

var hasSharingEnabled = function() {

	return serverData.event.hasSharingEnabled;

};

var hasCommentsEnabled = function() {

	return serverData.event.hasCommentsEnabled;

};

var hasFileNamesEnabled = function() {

	return serverData.event.hasFileNamesEnabled;

};

var hasWatermarkEnabled = function() {

	return serverData.event.hasWatermarkEnabled;

};

var hasScrollRestorationSupport = function() {

	return 'scrollRestoration' in history;

};

var addGalleryToHistoryStack = function(action, galleryIndex) {

	var stateObj = {galleryIndex: galleryIndex};

	window.history[action + 'State'](
		stateObj,
		getGalleryMeta(galleryIndex).name,
		getGalleryUrl(galleryIndex)
	);

};

var saveGalleryData = function(index, data) {

	galleryData = data;

	triggerCustomEvent('gallery_data_saved', {
		data: {
			galleryIndex: index,
			galleryData: data,
			isFavoritesGallery: isFavoritesGallery(index)
		}
	});

};

var requestGalleryData = function(opts) {

	var url;
	var galleryIndex;

	opts = opts || {};

	galleryIndex = typeof opts.galleryIndex === 'undefined' ? getGalleryIndex() : opts.galleryIndex;
	url = getGalleryUrl(galleryIndex);

	if (!isCachableGallery(galleryIndex)) {

		// Append a timestamp to the url so it will never be found in the cache
		// factory and a fresh request will be made each time.

		url += '?ts=' + Date.now();

	}

	// The selected gallery may or may not be in our internal cache. If not,
	// an ajax request will be made, otherwise the data will immediately be
	// returned from the cache.

	// console.log('url: ' + url)
	// debugger;

	if (isFavoritesGallery(galleryIndex) && lastPageData.galleryIndex && isFavoritesGallery(lastPageData.galleryIndex)) {

		// If we're going back/forward between the favorites grid and slideshow, do not get new favorite data, we want to keep the data in sync with the DOM since we are no longer building the grid markup fresh each time

		sidePanel.close();
		triggerCustomEvent('gallery_data_ready');


	} else {

		fetch(url, function(response) {

			if (response.status.detail === 'gallery_load_successful') {

				if (opts.historyAction) {

					addGalleryToHistoryStack(opts.historyAction, opts.galleryIndex);

				}

				saveGalleryData(galleryIndex, response.galleryData);
				sidePanel.close();
				triggerCustomEvent('gallery_data_ready');

			} else {

				triggerCustomEvent(response.status.detail, {
					data: {
						response: response
					}
				});

			}

		});

	}

};

var addEventHandlers = function() {

	appDom.document.on('app_ready', requestGalleryData);

	// Proxy popstate events to the app so we can guarantee the fix in this handler
	// gets applied first.
	appDom.window.on('popstate', function(e) {

		var y;

		// Safari fires the popstate event on page load. We want to ignore this
		// as it is incorrect behavior. We can identify this scenario by
		// checking the value of the history state, as it will be null on initial
		// load.

		if (e.originalEvent.state) {

			// if (appDom.app.hasClass('app--is-slideshow-compare-frame')) {
			// 	top.history.back();
			// 	return;
			// }

			requestGalleryData();

			// If browser does not support scroll restoration, we need to add a one-time scroll handler to undo the auto scroll restoration the browser will apply once the popstate handler finishes
			if (!hasScrollRestorationSupport()) {

				y = window.pageYOffset;

				appDom.window.one('scroll', function() {

					window.scrollTo(0, y);

				});

			}

			if (slideshowUtils.isSlideshowZoomActive()) {

				triggerCustomEvent('popstate_while_slideshow_zoom_active');

			} else if (slideshowUtils.isSlideshowCompareActive()) {

				triggerCustomEvent('popstate_while_slideshow_compare_active');

			}

		}

	});

	appDom.document.on('side_panel_closed', function(e, data) {

		// If the contact login modal is closed by the user and we're on the
		// favorites gallery page, take the user to the first gallery. The
		// only way this scenario could happen is if the user direct links to
		// the favorites gallery and is not signed in as a contact.

		if (isFavoritesGallery() && data.panelType === 'contact-login' && data.closeTrigger === 'user') {

			requestGalleryData({
				historyAction: getHistoryAction(),
				galleryIndex: 0
			});

		}

	});

	// The user was not signed in as a contact when they tried to load the
	// favorites gallery. Upon successfull sign in, this event will fire.
	appDom.document.on('load_favorites', function() {

		requestGalleryData({
			historyAction: getHistoryAction(),
			galleryIndex: getFavoritesGalleryIndex()
		});

	});

	appDom.document.on('slideshow_grid_btn_clicked slideshow_escape_key_pressed', function() {

		var galleryIndex = getGalleryIndex();

		// Chrome iOS does not allow pushState calls unless triggered from a user action, so we can't manipulate the history stack on initial page load of a deep linked slideshow (we would replace the current state with a gallery state then push the slideshow state). As a workaround, we'll check here if we're in a deep linked slideshow and adjust the stack as necessary.

		if (window.history.state.isDeepLink) {

			// Since there is special logic in requestGalleryData() for keeping favorites data in sync, we have to handle replacing the current state ourselves
			if (isFavoritesGallery(galleryIndex)) {

				addGalleryToHistoryStack('replace', galleryIndex);

			}

			// Trigger the normal application loading flow and replace the deep linked slideshow state with it's associated gallery
			requestGalleryData({
				historyAction: getHistoryAction(),
				galleryIndex: galleryIndex
			});

		} else {

			// We entered into this slideshow the "normal" way, by clicking on a grid image, so we can safely go back
			history.back();

		}

	});

	// Add a gallery to the history stack.
	appDom.document.on('gallery_select_gallery_selected gallery_list_gallery_selected main_nav_gallery_selected breadcrumb_event_name_clicked', function(e, data) {

		var galleryIndex = typeof data.galleryIndex !== 'undefined' ? data.galleryIndex : getGalleryIndex();

		console.log('galleryIndex: ' + galleryIndex);

		requestGalleryData({
			historyAction: getHistoryAction(),
			galleryIndex: galleryIndex
		});

	});

	appDom.document.on('image_grid_image_clicked', function(e, data) {

		var stateObj = window.history.state;
		var imageMeta = getImageMeta(data.imageIndex);

		stateObj.slideshowIndex = data.imageIndex;

		window.history.pushState(
			stateObj,
			imageMeta.friendlyName,
			window.location.pathname + '/' + imageMeta.friendlyName
		);

		triggerCustomEvent('slideshow_state_pushed');

	});

	// Replace the current state with the new image info.
	appDom.document.on('slideshow_image_changed', function(e, data) {

		var stateObj = window.history.state;
		var curUrl = window.location.pathname;
		var splitPath = curUrl.split('/');
		var imageMeta = getImageMeta(data.imageIndex);

		stateObj.slideshowIndex = data.imageIndex;
		splitPath[splitPath.length - 1] = imageMeta.friendlyName;

		window.history.replaceState(
			stateObj,
			imageMeta.friendlyName,
			splitPath.join('/')
		);

	});

	// user does not have access to event
	appDom.document.on('event_access_denied', function() {

		// send to event login
		window.location = getEventUrl();

	});

};

var setupInitialApplicationState = function() {

	var galleryIndex = serverData.initialGalleryIndex;
	var slideshowIndex = serverData.initialSlideshowIndex;
	var stateObj = {galleryIndex: galleryIndex};
	var isSlideshow = typeof slideshowIndex !== 'undefined';
	var url = getGalleryUrl(galleryIndex);
	var title = getGalleryMeta(galleryIndex).name;
	var queryIndex = location.href.indexOf('?');
	var queryParams = queryIndex !== -1 ? location.href.substr(queryIndex) : '';
	var imageMeta;

	if (isSlideshow) {

		// We deep linked into a slideshow.

		imageMeta = getImageMeta(slideshowIndex);
		stateObj.slideshowIndex = slideshowIndex;
		stateObj.isDeepLink = true;
		title = imageMeta.friendlyName;
		url += '/' + imageMeta.friendlyName;

	}

	// Setup the state data for the page
	window.history.replaceState(stateObj, title, url + queryParams);

};

var init = function() {

	// If this browser supports it, turn off auto scroll restoration since it conflicts with us trying to scroll the page to the last slideshow image
	if (hasScrollRestorationSupport()) {

		history.scrollRestoration = 'manual';

	}

	galleryData = serverData.initialGalleryData.galleryData;

	addEventHandlers();

	setupInitialApplicationState();

	// Cache the image data for the current gallery.
	console.log('init gallery url...' + getGalleryUrl());
	setupCacheFactory(getGalleryUrl(), serverData.initialGalleryData);

};

module.exports = {
	init: init,
	isSlideshowState: isSlideshowState,
	isGridState: isGridState,
	isFavoritesGallery: isFavoritesGallery,
	hasFavoritesEnabled: hasFavoritesEnabled,
	hasEcommerceEnabled: hasEcommerceEnabled,
	hasDownloadsEnabled: hasDownloadsEnabled,
	hasSharingEnabled: hasSharingEnabled,
	hasCommentsEnabled: hasCommentsEnabled,
	hasFileNamesEnabled: hasFileNamesEnabled,
	hasWatermarkEnabled: hasWatermarkEnabled,
	getSlideshowIndex: getSlideshowIndex,
	getImageMeta: getImageMeta,
	getImageUrl: getImageUrl,
	getSlideshowUrl: getSlideshowUrl,
	getGalleryMeta: getGalleryMeta,
	getGalleryData: getGalleryData,
	getGalleryIndex: getGalleryIndex,
	getGalleryUrl: getGalleryUrl,
	getEventUrl: getEventUrl,
	getEventName: getEventName,
	getEventKey: getEventKey,
	getEventDefaultShareImage: getEventDefaultShareImage,
	getWatermarkMeta: getWatermarkMeta,
	getPhotographerAccountId: getPhotographerAccountId,
	getPhotographerCompanyName: getPhotographerCompanyName,
	setLastPageData: setLastPageData,
	getLastPageData: getLastPageData
};
